import { useContext, useEffect, useState } from 'react'

import { Tabs } from 'antd'
import { useSelector } from 'react-redux'
import { faCalendar, faList } from '@fortawesome/pro-solid-svg-icons'

import InternshipsManagerView from '../../shared/InternshipsManagerView'
import { InternshipMessageContext } from '../../../Providers/InternshipMessageProvider'
import { selectUser } from '../../../reducers/UserReducer'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import useSessionStorage from '../../../hooks/UseSessionStorage'
import IconLabel, { FontSizes } from '../../../Components/icons/IconLabel'
import { isPremiumUser } from '../../../utils/roles'
import IndividualInternshipRequestModal from '../../../Providers/Forms/IndividualInternshipRequest/IndividualInternshipRequestModal'
import InternshipRequestFilesDrawer from '../../institution/InternshipsView/InternshipRequestsView/InternshipRequestFilesDrawer'
import InternshipRequestsView from '../../institution/InternshipsView/InternshipRequestsView/InternshipRequestsView'
import { SchoolContext } from '../../../Providers/SchoolProvider'
import SelectProvider from '../../../Providers/SelectProvider'
import { RequestPortalContext } from '../../../Providers/RequestPortalProvider'
import { getIdOrNull } from '../../../utils'
import LinkWithSchoolModal from '../../InternshipRequestPortal/LinkWithSchoolModal'

const { TabPane } = Tabs

export const INTERNSHIP_VIEW_ACTIVE_TAB_KEY = 'institution.internships_view_active_key'

/** @enum {string} */
export const InternshipsViewTabs = Object.freeze({
  CALENDAR: '1',
  REQUESTS: '2'
})

const InternshipsView = ({ loadShiftsManager }) => {
  const { institutions, school, schoolSections } = useContext(SchoolContext)
  const { setTrackedInternships } = useContext(InternshipMessageContext)
  const { institution } = useContext(RequestPortalContext)

  const user = useSelector(selectUser)
  const t = useSelector(selectTranslate)

  const [activeTab, setActiveTab] = useSessionStorage(INTERNSHIP_VIEW_ACTIVE_TAB_KEY + user.id, InternshipsViewTabs.CALENDAR)

  const [linkWithSchoolModal, setLinkWithSchoolModal] = useState(false)

  useEffect(() => () => setTrackedInternships([]), [])

  useEffect(() => {
    if (getIdOrNull(institution)) {
      setLinkWithSchoolModal(true)
    }
  }, [institution])

  const handleModalClose = () => {
    setLinkWithSchoolModal(false)
  }

  return (
    <Tabs activeKey={activeTab} animated={false} onChange={setActiveTab}>
      <TabPane
        key={InternshipsViewTabs.CALENDAR}
        tab={<IconLabel fontSize={FontSizes.SMALL} icon={faCalendar} text={t('internships_view.titles.internships_timeline')} />}
      >
        <SelectProvider>
          <LinkWithSchoolModal institution={institution} visible={linkWithSchoolModal} onClose={handleModalClose}>
            <InternshipsManagerView loadShiftsManager={loadShiftsManager} />
          </LinkWithSchoolModal>
        </SelectProvider>
      </TabPane>
      {isPremiumUser(user) && (
        <TabPane
          key={InternshipsViewTabs.REQUESTS}
          tab={<IconLabel fontSize={FontSizes.SMALL} icon={faList} text={t('internships_view.titles.internships_request')} />}
        >
          <IndividualInternshipRequestModal
            institutions={institutions}
            schools={{ data: [school], loading: false }}
            sectors={[]}
            schoolSections={schoolSections}
          >
            <InternshipRequestFilesDrawer>
              <InternshipRequestsView />
            </InternshipRequestFilesDrawer>
          </IndividualInternshipRequestModal>
        </TabPane>
      )}
    </Tabs>
  )
}

export default InternshipsView
